import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AssetsService} from "../services/assets.service";
import {UserService} from "../services/user.service";
import {BankService} from "../services/bank.service";
import {PagerserviceService} from "../services/pagerservice.service";
import {NotificationsService} from "angular2-notifications";
import {PuserserviceService} from "../services/puserservice.service";
import {Globals} from "../app-globals";
import {AdminService} from "../services/admin.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import * as XLSX from 'xlsx';
import { APP_CONSTS } from '../consts/app.consts';
import { MatDialog } from '@angular/material';
import { FiatWithdrawRejectDialog } from '../fiatrejectconfirm/fiatwithdrawrejectconfirm.component';

@Component({
    selector: 'app-withdraw',
    templateUrl: './fiatwithdraw.component.html',
    styleUrls: ['./fiatwithdraw.component.css']
})
export class FiatWithdrawComponent implements OnInit {
    /*store all transaction list variable*/
    withdrawlist: Array<any>;
    /* Search variables */
    FilPerpage: number;
    FilPage: number;
    filter: Boolean;
    /************************************/
    // pager Number
    pager: number;
    Tpager: number;
    public settings:any
    // pager object
    pager1: any = {};
    searchObj = {
        time1: new Date(),
        time: new Date(),
        search : ''
    }
    //search option
    search = '';
    statusoption = '';
    permission: string;
    customer: Boolean;
    fileName:string;
    currentPage = 0;
    withdrawlistexport = [];
    constructor(private router: Router,
                private assetService: AssetsService,
                private userService: UserService,
                private bankService: BankService,
                private pagerService: PagerserviceService,
                private spinnerService: Ng4LoadingSpinnerService,
                private notifSer: NotificationsService,
                private pusherService: PuserserviceService,
                private adminService: AdminService,
                private global: Globals,
                public dialog: MatDialog) {
    }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.adminService.groupupdate.subscribe(permData => {
                localStorage.setItem('permission', permData.permission);
                this.permission = permData.permission
            })
            this.permission = this.adminService.getPermission();
            this.customer = false;
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.pager = 1;
            this.getWithdrawList();
        }
    }

    getWithdrawList() {
        this.spinnerService.show();
        this.bankService.getfiatWithdrawList(this.FilPerpage, this.FilPage, this.searchObj,false).subscribe((success) => {
            this.spinnerService.hide();
            if (success.status) {
                this.withdrawlist = success.withdraw;
                this.currentPage = success.current;
                this.Tpager = success.pages;
                this.setPage(this.FilPage);
            }
        }, (error) => {
            this.withdrawlist = []
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }


    getWithdrawListexp() {
        this.spinnerService.show();
        this.bankService.getfiatWithdrawList(this.FilPerpage, this.FilPage, this.searchObj,true).subscribe((success) => {
            this.spinnerService.hide();
            this.withdrawlistexport = [];
            if (success.status) {
                this.withdrawlist = success.withdraw;
                for (let i = 0; i < this.withdrawlist.length; i++) {  
                    this.withdrawlistexport.push({ 
                        'Timestamp':this.withdrawlist[i].createdAt ? this.withdrawlist[i].createdAt : '',
                        'User Legal Name':this.withdrawlist[i].user.name ? this.withdrawlist[i].user.name : '',
                        'Email':this.withdrawlist[i].user_email ? this.withdrawlist[i].user_email : '',
                        'Currency': this.withdrawlist[i].currency ? this.withdrawlist[i].currency : '',
                        'Amount':this.withdrawlist[i].amount ? this.withdrawlist[i].amount : '',
                        'Transfer':this.withdrawlist[i].transfer_amount ? this.withdrawlist[i].transfer_amount : '',
                        'Txn ID':this.withdrawlist[i].txnid ? this.withdrawlist[i].txnid : '',
                        'Fee':this.withdrawlist[i].withdraw_fee ? this.withdrawlist[i].withdraw_fee : '',
                        'Bank Name':this.withdrawlist[i].bank_name ? this.withdrawlist[i].bank_name : '',
                        'Account Holder Name':this.withdrawlist[i].account_holder_name ? this.withdrawlist[i].account_holder_name : '',
                        'Account Number':this.withdrawlist[i].account_number ? this.withdrawlist[i].account_number : '',
                        'IFSC Code':this.withdrawlist[i].ifsc_code ? this.withdrawlist[i].ifsc_code : '',
                        'IBAN Number':this.withdrawlist[i].iban_number ? this.withdrawlist[i].iban_number : '',
                        'BIC Code':this.withdrawlist[i].bic_code ? this.withdrawlist[i].bic_code : '',
                        'Reference ID':this.withdrawlist[i].otctxnid ? this.withdrawlist[i].otctxnid : '',
                        'Admin Bank Name':this.withdrawlist[i].refnumber ? this.withdrawlist[i].refnumber : '',
                        'Note':this.withdrawlist[i].note ? this.withdrawlist[i].note : '',
                        'Authorized By': this.withdrawlist[i].status ? this.withdrawlist[i].status :''
                    })
                }
            this.fileName = 'Fiat Withdraw Report.xlsx'
            const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.withdrawlistexport);
        
            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      
            /* save to file */
            XLSX.writeFile(wb, this.fileName);
            }
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    SearchWithdrawStatus(target) {
        this.spinnerService.show();
        this.statusoption = target.target.value;
        this.bankService.getWithdrawList(this.FilPerpage, this.FilPage, this.searchObj,false).subscribe((success) => {
            if (success.status) {
                this.withdrawlist = success.withdraw;
                this.Tpager = success.pages;
                this.setPage(this.FilPage);
            }
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    SearchWithdraw(target) {
        this.spinnerService.show();
        this.searchObj.search = target.target.value;
        this.bankService.getfiatWithdrawList(this.FilPerpage, this.FilPage, this.searchObj,false).subscribe((success) => {
            if (success.status) {
                this.withdrawlist = success.withdraw;
                this.Tpager = success.pages;
                this.setPage(this.FilPage);                
                this.withdrawlistexport = [];
            }
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.getWithdrawList();
    }
     /**
     * 
     * @param report export excel
     */
    exportExcel(report){
        this.fileName = 'WithdrawReport.xlsx'
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.withdrawlistexport);
        
            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      
            /* save to file */
            XLSX.writeFile(wb, this.fileName);
    }

    updatefiat(obj,status){
        var sendobj = {
            userid:obj.userid,
            status:(status)?APP_CONSTS.TRANSACTION_STATUS.APPROVED:APP_CONSTS.TRANSACTION_STATUS.REJECTED,
            amount:obj.amount,
            currency:obj.currency,
            withdraw_fee: obj.withdraw_fee,
            bank_account_number:obj.bank_account_number,
            _id:obj._id
        }
        this.dialog.open(FiatWithdrawRejectDialog, {
            data: sendobj,
            width: 'auto'
        }).afterClosed().subscribe(result => {
            if (result && result.success) {
                // Refresh the table data or perform any necessary updates
                this.getWithdrawList();
            }
        });
    }

    showApproveRejectButton(trans){
        return trans.status==APP_CONSTS.TRANSACTION_STATUS.PENDING
    }
}



// WEBPACK FOOTER //
// ./src/app/fiatwithdraw/fiatwithdraw.component.ts